import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Paragraph from '../Paragraph/Paragraph';
import { pxToRem } from '../../assets/styles/helper';
import themeColors from '../../assets/styles/themeColors';
import { ReactComponent as InfoIcon } from '../../assets/images/svg/info-ico.svg';

const InformationListItemContainer = styled.li`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: ${pxToRem(16)};

  ${({ noValue }) =>
    noValue &&
    `grid-template-columns: 1fr;
      grid-column-gap: 0;`};

  ${({ withBackground }) =>
    withBackground &&
    `
      background-color: ${themeColors.colorBackgroundSecondary};
      padding: ${pxToRem(4)} ${pxToRem(8)};
  `}

  ${({ isBold }) => isBold && `> p {font-weight: 600;}`};
  ${({ isValueBold }) => isValueBold && `> p {font-weight: 600;}`};

  ${({ fullWidth }) =>
    fullWidth &&
    `
      grid-template-columns: 1fr 1fr;

      > :last-child {
        text-align: right;
      }
  `};

  svg {
    margin-left: 6px;
    vertical-align: middle;
    cursor: pointer;
  }
`;

const InformationListItem = ({
  label,
  value,
  noValue,
  withBackground,
  fullWidth,
  isBold,
  isValueBold,
  whiteSpace,
  isColored,
  infoIcon,
  onClick,
}) => {
  if (!value && !noValue) {
    return null;
  }

  return (
    <InformationListItemContainer
      key={label}
      noValue={noValue}
      withBackground={withBackground}
      isBold={isBold}
      fullWidth={fullWidth}
    >
      <Paragraph bold={isBold}>
        {label}
        {infoIcon && (
          <InfoIcon onClick={onClick} fill={themeColors.colorTextSecondary} />
        )}
      </Paragraph>
      <Paragraph whiteSpace={whiteSpace} color={isColored} bold={isValueBold}>
        {value}
      </Paragraph>
    </InformationListItemContainer>
  );
};

InformationListItem.propTypes = {
  label: PropTypes.node,
  value: PropTypes.string,
  noValue: PropTypes.bool,
  withBackground: PropTypes.bool,
  fullWidth: PropTypes.bool,
  isBold: PropTypes.bool,
  isValueBold: PropTypes.bool,
  whiteSpace: PropTypes.bool,
  isColored: PropTypes.string,
  infoIcon: PropTypes.node,
  onClick: PropTypes.func,
};

export default InformationListItem;
